import React from 'react';

const Card = ({
  children,
  title,
  titleRight,
  className = 'card-w-border',
  footer,
  padding = 'p-6',
  ...props
}) => {
  return (
    <div className={`bg-white shadow rounded-lg border border-gray-300 ${className}`} {...props}>
      {(title || titleRight) && (
        <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between gap-3">
          {title ? <h3 className="text-lg font-medium text-gray-900">{title}</h3> : <span />}
          {titleRight}
        </div>
      )}

      <div className={padding}>{children}</div>

      {footer && <div className="border-t border-gray-200 px-6 py-4 bg-gray-50">{footer}</div>}
    </div>
  );
};

export default Card;
